import { useState } from "react";
import { Button, Space, message } from "antd";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { downloadSupportReport } from "../../../queries/reports";
import { ApiError } from "../../../hooks/apiRequest";

type Format = "xlsx" | "pdf";

/** Excel + PDF download of the support-team report for a date range (YYYY-MM-DD). */
export const ExportButtons = ({ from, to }: { from: string; to: string }) => {
  const [busy, setBusy] = useState<Format | null>(null);

  const run = async (format: Format) => {
    setBusy(format);
    try {
      await downloadSupportReport(format, from, to);
    } catch (err) {
      message.error(err instanceof ApiError ? err.message : "Could not generate the report");
    } finally {
      setBusy(null);
    }
  };

  return (
    <Space wrap>
      <Button icon={<FileExcelOutlined />} loading={busy === "xlsx"} disabled={busy !== null} onClick={() => run("xlsx")}>
        Download Excel
      </Button>
      <Button icon={<FilePdfOutlined />} loading={busy === "pdf"} disabled={busy !== null} onClick={() => run("pdf")}>
        Download PDF
      </Button>
    </Space>
  );
};
